import { Controller } from "@hotwired/stimulus";

/**
 * Microsite Upgrade Controller
 *
 * Gates the "Upgrade This Site" button behind the acknowledgement checkbox on
 * the V1-to-V2 upgrade page. The conversion is one way, so the confirmation is
 * deliberate rather than decorative.
 *
 * UX only. Admin::MicrositesController#perform_upgrade re-checks the policy and
 * whether the upgrade is still available, and is the source of truth.
 */
export class MicrositeUpgradeController extends Controller {
  static targets = ["acknowledgement", "submit", "hint"];

  toggleSubmit() {
    if (!this.hasSubmitTarget) return;

    const acknowledged = this.acknowledgementTarget.checked;
    this.submitTarget.disabled = !acknowledged;

    // Keep the reason next to the button while it is disabled, rather than
    // leaving a dead control with no explanation.
    if (this.hasHintTarget) this.hintTarget.hidden = acknowledged;
  }
}

export default MicrositeUpgradeController;
